<script lang="ts">
  /**
   * Small presentational control icon. Renders an inline, stroke-based SVG that
   * inherits the button's `currentColor`. Status icons swap their glyph via the
   * `on` prop (e.g. mic / mic-off). All shapes are simplified but recognizable.
   */
  export let name: string;
  export let on: boolean = true;
</script>

<svg
  viewBox="0 0 24 24"
  width="1.25em"
  height="1.25em"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
  aria-hidden="true"
  focusable="false"
>
  {#if name === "visibility"}
    {#if on}
      <path d="M2 12 s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7Z" />
      <circle cx="12" cy="12" r="3" />
    {:else}
      <path d="M2 12 s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7Z" />
      <circle cx="12" cy="12" r="3" />
      <path d="M3 3 L21 21" />
    {/if}
  {:else if name === "hand"}
    <path d="M8 11 V5 a1.5 1.5 0 0 1 3 0 V11 V4 a1.5 1.5 0 0 1 3 0 V11 V6 a1.5 1.5 0 0 1 3 0 V14 a6 6 0 0 1-6 6 h-1 a5 5 0 0 1-4-2 l-3-4 a1.5 1.5 0 0 1 2.5-1.6 L8 12Z" />
  {:else if name === "mic"}
    <path d="M12 2 a3 3 0 0 0-3 3 v6 a3 3 0 0 0 6 0 V5 a3 3 0 0 0-3-3Z" />
    <path d="M19 10 v1 a7 7 0 0 1-14 0 v-1" />
    <path d="M12 18 v4" />
    <path d="M8 22 h8" />
    {#if !on}
      <path d="M3 3 L21 21" />
    {/if}
  {:else if name === "camera"}
    <path d="M2 7 a2 2 0 0 1 2-2 h9 a2 2 0 0 1 2 2 v10 a2 2 0 0 1-2 2 H4 a2 2 0 0 1-2-2Z" />
    <path d="M17 9 l5-3 v12 l-5-3Z" />
    {#if !on}
      <path d="M3 3 L21 21" />
    {/if}
  {:else if name === "sound"}
    <path d="M4 9 v6 h4 l5 4 V5 L8 9Z" />
    {#if on}
      <path d="M16 8 a5 5 0 0 1 0 8" />
      <path d="M19 5 a9 9 0 0 1 0 14" />
    {:else}
      <path d="M22 9 l-6 6" />
      <path d="M16 9 l6 6" />
    {/if}
  {:else if name === "text"}
    <path d="M21 12 a8 7 0 0 1-8 7 H7 l-4 3 v-4.5 A8 7 0 1 1 21 12Z" />
  {:else if name === "lock"}
    <!-- on = closed (encrypted); off = open shackle (unencrypted) -->
    <rect x="5" y="11" width="14" height="9" rx="2" />
    {#if on}
      <path d="M8 11 V7 a4 4 0 0 1 8 0 v4" />
    {:else}
      <path d="M8 11 V7 a4 4 0 0 1 7-2.5" />
    {/if}
  {/if}
</svg>
